import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';

export const useWasPreviousMetroRoute = (): boolean => {
  const router = useRouter();
  const [wasMetro, setWasMetro] = useState<boolean>(false);

  useEffect(() => {
    const handleRouteChangeStart = () => {
      const currentPath = router.pathname;

      const isMetroRoute =
        currentPath.startsWith('/categories/') ||
        currentPath.startsWith('/metro') ||
        currentPath.startsWith('/market-category') ||
        currentPath.startsWith('/favorite-product');
      const isCartOrCheckout = currentPath.startsWith('/cart') || currentPath.startsWith('/checkout');

      if (isMetroRoute) {
        setWasMetro(true);
      } else if (!isCartOrCheckout) {
        setWasMetro(false);
      }
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, [router]);

  return wasMetro;
};
